import { getMissionAccountFilter, getShiftPositionAccountFilter } from '../../../../backend/features/shift';
import { getTrainAccountFilter } from '../../shift/utils/getTrainAccountFIlter';
export const getQualifiedParticipantsFilter = ({ isTrainFeatureEnabled, missionOrganizationSharing, missionGroupSharing, position, deploymentDurations, }) => [
    ...getMissionAccountFilter({ missionOrganizationSharing, missionGroupSharing }),
    ...getShiftPositionAccountFilter({
        deploymentDurations,
        position,
    }),
    ...(isTrainFeatureEnabled && position.trainCourseIds ? getTrainAccountFilter(position.trainCourseIds) : []),
];
